export default __webpack_public_path__ + "static/media/loginBg.95f9a08f.jpg";